import React, { useState } from "react";
import { Form, Typography, Divider, Input, Button, Row, Col, Space, Radio, Alert, Checkbox, Tabs, Card, message } from "antd";
import WebstoreItem from "../WebstoreItem";
import { apiCall } from "../../../utils/Api";
import conditional from "../../../utils/conditional";
import { useSession } from "../../../utils/Session";
import Editor from "react-medium-editor/dist/editor";
import MSWrap from "./MSWrap";
import { drawMSFooter, drawMSTitleBar } from "../../../utils/Utils";
import MultistoreItem from "../MultistoreItem";
export default function OrderingSection(props) {

    const { ws, form, setChanged = () => { } } = props;
    const default_ws_message_pickup = "We will contact you during normal business hours to confirm availability, final pricing, taxes or shipping charges (if applicable). We can be reached by phone at @@phone@@ or by email at @@email@@ should you have any questions or concerns.";
    const [session, setSession] = useSession();
    const [loading, setLoading] = useState(false);

    const [shipChecked, setShipChecked] = useState((ws["global:active_custom_ship"]) ? true : false);
    const [pickupChecked, setPickupChecked] = useState((ws["global:active_custom_pickup"]) ? true : false)

    const primary = (window.sitesettings.stores[0]);
    const stores = (primary.is_primary) ? window.sitesettings.stores : [window.sitesettings.stores.find(item => item.is_primary)];

    const convertOO = () => {
        let _ret = {}
        stores.forEach(item => {
            _ret["ms" + item.store_number + ":enable_online_ordering"] = (ws[`ms${item.store_number}:enable_online_ordering`]) ? true : false
        });
        return _ret;
    }

    const [enableOO, setEnableOO] = useState(convertOO());

    const verifyEmail = (_prefix) => {
        apiCall("settings/verifyEmail", { email: form.getFieldValue(_prefix + ":order_email") }, (_status, _results) => {
            if (_status) {
                message.success("Email is verified");
            } else {
                message.error(_results.error)
            }
        })
    }

    const checkPreference = () => {

        let one_selected = false;

        if (form.getFieldValue(["allowed_comm_prefs", "email"])) {
            one_selected = true;
        }
        if (form.getFieldValue(["allowed_comm_prefs", "phone"])) {
            one_selected = true;
        }
        if (form.getFieldValue(["allowed_comm_prefs", "text"])) {
            one_selected = true;
        }

        if (!one_selected) {
            form.setFieldsValue({ ["allowed_comm_prefs"]: { email: true, phone: false, text: false } });
        }


    }

    return (
        <>
            <div id="ordering" style={{ "padding": "10px 30px" }}>
                <Typography.Title level={4}>Ordering</Typography.Title>
                <Divider />

                <div id="enable_online_ordering" />
                <MultistoreItem
                    onChange={(e, _name) => setEnableOO({ ...enableOO, [_name]: e })}
                    stores={stores}
                    ws={ws}
                    name="enable_online_ordering"
                    heading="Enable online ordering"
                    description={<div>Checking this box provides your customers with an online cart to build and submit orders. If you do not check this box, they will still be able to browse and search titles, but they will have to contact you directly to place an order.</div>}
                />

                <div id="order_email" />
                <Space>
                    <div style={{ "width": "35px" }}></div>
                    <div>
                        <Typography.Title level={5}>Orders email address</Typography.Title>
                        <Typography.Paragraph type="secondary">This email address should be continually monitored for incoming orders.</Typography.Paragraph>

                        {stores.map((item, index) => {
                            return (
                                <>
                                    <conditional.true value={(stores.length > 1)}>
                                        <div style={{ "height": "24px", "overflow": "hidden", "lineHeight": "27px" }}>{item.name}</div>
                                    </conditional.true>
                                    <conditional.true value={(!enableOO["ms" + item.store_number + ":enable_online_ordering"])}>
                                        <Typography.Paragraph type="danger">"Enable online ordering" must be enabled</Typography.Paragraph>
                                    </conditional.true>
                                    <Form.Item rules={[{ required: (enableOO["ms" + item.store_number]), type: "email", message: "Must be a valid email." }]} initialValue={ws[`ms${item.store_number}:order_email`]} name={`ms${item.store_number}:order_email`}>
                                        <Input disabled={(!enableOO["ms" + item.store_number + ":enable_online_ordering"])} type="email" style={{ "maxWidth": "500px" }} suffix={<Button disabled={(!enableOO["ms" + item.store_number + ":enable_online_ordering"])} loading={loading} onClick={() => verifyEmail(`ms${item.store_number}`)} type="primary">Verify Email</Button>} enterButton="Verify email" placeholder="name@email.com" />
                                    </Form.Item>
                                </>
                            )
                        })}

                    </div>
                </Space>
                <Divider dashed />

                {/* Allow Guest Checkout */}
                {/* <div id="ws_guest_checkout" />
                <MultistoreItem
                    stores={stores}
                    ws={ws}
                    name="ws_guest_checkout"
                    heading="Allow Guest Checkout"
                    description={<div>Provides your customers a Guest Checkout option at the cart. Guest Checkout is faster than regular Account Creation checkout, as customers do not need to create a full account with address details to proceed. Guest Checkout can only be used on carts where all items are in stock. <br /><br />Guest Checkout is not available for carts that contains titles that need to be ordered, or if the customer would like their order shipped / locally delivered. Depending on your Payment settings, customers can choose to pay at pick up or prepay their Guest order. Gift Cards can be used with Guest Checkout, but certain promo codes require a regular account (they must be logged in) to qualify.</div>}
                />
                <Divider dashed /> */}


                {/* Delivery Pickup Enabled */}
                <div id="ws_delivery_pickup_enabled" />
                <MultistoreItem
                    stores={stores}
                    ws={ws}
                    name="ws_delivery_pickup_enabled"
                    heading="Allow in-Store pick up"
                    description={<div>Upon checkout, customers can choose to pick up their order at your physical store location rather than have it shipped. We highly recommend checking this option, as the vast majority of online orders come from locals who are more than happy to pick their order up to avoid shipping costs or shipping delays. If you are a store with multiple locations, use the Multi-Store menu to customize and specify pickup locations and details.</div>}
                />
                <Divider dashed />


                {/* Allow Quote Checkout */}
                <div id="ws_quotes_enabled" />
                <MultistoreItem
                    stores={stores}
                    ws={ws}
                    name="ws_quotes_enabled"
                    heading="Allow Quote Checkout"
                    description={<div>When enabled, customers can choose "Request a Quote" upon checkout. This checkout option will not require payment, but will generate a "Quote" type held sale in the Bookmanager software if the Webstore option "Submitted orders will automatically generate a Held Sale in my Bookmanager system" has been enabled.</div>}
                />
                <Divider dashed />



                <Divider dashed />
                {/* Available to Order wording: */}
                <div id="ws_order_wording"></div>
                <Space>
                    <div style={{ "width": "35px" }}></div>
                    <div>
                        <Typography.Title level={5}>Available to Order wording:</Typography.Title>
                        <Typography.Paragraph type="secondary">Choose the wording shown for titles that you do not have in stock and will order for the customer.</Typography.Paragraph>
                        <Form.Item initialValue={ws["global:ws_order_wording"]} noStyle name="global:ws_order_wording">
                            <Radio.Group>
                                <Radio value={0}>Special order</Radio>
                                <div className="shim"></div>
                                <Radio value={1}>Available to order</Radio>
                                <div className="shim"></div>
                                <Radio value={2}>Special order (not in store)</Radio>
                                <div className="shim"></div>
                                <Radio value={3}>Available to order (not in store)</Radio>
                                <div className="shim"></div>
                            </Radio.Group>
                        </Form.Item>
                    </div>
                </Space>


                <Divider dashed />
                {/* Not available to Order wording: */}
                <div id="ws_no_price_wording"></div>
                <Space>
                    <div style={{ "width": "35px" }}></div>
                    <div>
                        <Typography.Title level={5}>Not in stock and unavailable to order wording:</Typography.Title>
                        <Typography.Paragraph type="secondary">Choose the wording shown for titles that you do not have in stock and are unavailable to order.</Typography.Paragraph>
                        <Form.Item initialValue={ws["global:ws_no_price_wording"]} noStyle name="global:ws_no_price_wording">
                            <Input placeholder="Custom button label..." maxLength={60} style={{ "maxWidth": "500px" }}></Input>
                        </Form.Item>
                    </div>
                </Space>


                <Divider dashed />
                {/* Enable cart abandonment reminder email */}
                <div id="ws_cart_abandonment_email_enabled" />
                <WebstoreItem
                    name="global:ws_cart_abandonment_email_enabled"
                    value={(ws["global:ws_cart_abandonment_email_enabled"]) ? true : false}
                    heading="Enable cart abandonment reminder email"
                    description={<div>If you check this box, an automated email will be sent to your customers who did not complete their cart checkout. The reminder email will contain a quick link for your customer to complete their purchase. (The email will come from your store, and only one email reminder per cart will ever be sent.)</div>}
                />

                <Divider dashed />
                {/* Submitted orders will auto generate a Held Sale in Bookmanager */}
                <div id="spool_order_files" />
                <WebstoreItem
                    onChange={(e) => props.setAutoHeldSale(e)}
                    name="global:spool_order_files"
                    value={(ws["global:spool_order_files"]) ? true : false}
                    heading="Submitted orders will auto generate a Held Sale in Bookmanager"
                    description={<div>If this box is not checked, you will only receive an email notification that a new customer order has been submitted.</div>}
                />

                <Divider dashed />
                {/* Adjust online On Hand quantities when orders are placed by customers */}
                <div id="ws_adjust_onhand_with_orders" />
                <WebstoreItem
                    name="global:ws_adjust_onhand_with_orders"
                    value={(ws["global:ws_adjust_onhand_with_orders"]) ? true : false}
                    // notice="Note: If you are using a version of Bookmanager that supports real-time updates of your webstore, leave this setting unchecked."
                    heading="Adjust online On Hand quantities when orders are placed by customers"
                    description={<div>If this option is checked, the onhand quantity for a title will be reduced by the quantity ordered when orders are placed. The onhand quantity will not become negative after a reduction, in such case it will remain zero. On order quantity is unaffected.</div>}
                />
                <Divider dashed />

                {/* My Pubstock suppliers must have stock on hand (or NYR) to be considered a source of supply. */}
                <div id="ws_no_cart_unless_onhand" />
                <WebstoreItem
                    name="global:ws_no_cart_unless_onhand"
                    value={(ws["global:ws_no_cart_unless_onhand"]) ? true : false}
                    heading="My Pubstock suppliers must have stock on hand (or NYR) to be considered a source of supply."
                    description={<div>The cart is hidden for special orders when none of your suppliers have stock (except for NYR titles). This is to discourage ordering titles that your suppliers cannot immediately supply.</div>}
                />

                <Divider dashed />
                {/* Hide customer cart for ISBNs that are Out Of Stock (OS) or Out of Stock Indefinitely (OSI), except when you have it on On Hand or On Order. */}
                <div id="ws_no_cart_osi" />
                <WebstoreItem
                    name="global:ws_no_cart_osi"
                    value={(ws["global:ws_no_cart_osi"]) ? true : false}
                    heading="Hide customer cart for ISBNs that are Out Of Stock (OS) or Out of Stock Indefinitely (OSI), except when you have it on On Hand or On Order."
                    description={<div>If you check this box, your customers will not be able to order any titles that have been designated by a publisher or vendor as OS or OSI status. However, if you currently stock the item and/or have it On Order, the customer cart will still appear for that item allowing them to order it.</div>}
                />
                <Divider dashed />

                {/* Do not remove ISBNs that are Out Of Stock, Out Of Stock Indefinitely, or Out Of Print from a customer's cart */}
                <div id="ws_allow_order_osi" />
                <WebstoreItem
                    name="global:ws_allow_order_osi"
                    value={(ws["global:ws_allow_order_osi"]) ? true : false}
                    heading="Do not remove ISBNs that are Out Of Stock, Out Of Stock Indefinitely, or Out Of Print from a customer's cart"
                    description={<div>If you check this box, your customers will be able to order items that you currently do not have and may not be able to get.</div>}
                />

                <Divider dashed />
                {/* Street address In footer: */}
                <div id="ws_hide_cart_price_if_anon" />
                <Space>
                    <div style={{ "width": "35px" }}></div>
                    <div>
                        <Typography.Title level={5}>When a customer is not logged in:</Typography.Title>
                        <div className="shim"></div> <div className="shim"></div>
                        <Form.Item initialValue={ws["global:ws_hide_cart_price_if_anon"]} noStyle name="global:ws_hide_cart_price_if_anon">
                            <Radio.Group>
                                <Radio value={0}>Show both cart and prices <br /><Typography.Paragraph type="secondary">If selected, customers will be able to see cart and prices even if not logged in</Typography.Paragraph></Radio>
                                <div className="shim"></div>
                                <Radio value={1}>Hide cart and show prices <br /><Typography.Paragraph type="secondary">If selected, customers will be required to log in before they can see the cart</Typography.Paragraph></Radio>
                                <div className="shim"></div>
                                <Radio value={2}>Hide both cart and prices <br /><Typography.Paragraph type="secondary">If selected, customers will be required to log in before they can see the cart and prices</Typography.Paragraph></Radio>
                                <div className="shim"></div>
                            </Radio.Group>
                        </Form.Item>
                    </div>
                </Space>

                <Divider dashed />
                {/* Show order inscription option */}
                <div id="ws_show_order_inscription_field" />
                <WebstoreItem
                    name="global:ws_show_order_inscription_field"
                    value={(ws["global:ws_show_order_inscription_field"]) ? true : false}
                    heading="Show order inscription option"
                    description={<div>When left unchecked, the customer will have an optional “Instructions” field to use upon checkout. If you want this field to be renamed to “Inscription”, check this option. This is used for stores selling personalized signed editions by the author. Most users should leave this unchecked.</div>}
                />

                <Divider dashed />
                {/* Communication Preferences */}
                <div id="allowed_comm_prefs" />
                <Space >
                    <div style={{ "width": "35px" }}></div>
                    <div>
                        <Typography.Title level={5}>Communication Preferences</Typography.Title>
                        <Typography.Paragraph type="secondary">Select which communication preferences will be offered to customers during account creation and checkout. You must enable texting within the Bookmanager software for the <strong>text</strong> option to appear for customers, regardless of the setting here. <em>At least one option must be selected.</em></Typography.Paragraph>
                        <Space direction="vertical">
                            <Form.Item noStyle valuePropName="checked" initialValue={ws["global:allowed_comm_prefs"]["email"]} name={["global:allowed_comm_prefs", "email"]}>
                                <Checkbox onChange={(e) => checkPreference(e)}>Email</Checkbox>
                            </Form.Item>
                            <Form.Item noStyle valuePropName="checked" initialValue={ws["global:allowed_comm_prefs"]["phone"]} name={["global:allowed_comm_prefs", "phone"]}>
                                <Checkbox onChange={(e) => checkPreference(e)}>Phone</Checkbox>
                            </Form.Item>
                            <Form.Item noStyle valuePropName="checked" initialValue={ws["global:allowed_comm_prefs"]["text"]} name={["global:allowed_comm_prefs", "text"]}>
                                <Checkbox onChange={(e) => checkPreference(e)}>Text</Checkbox>
                            </Form.Item>
                        </Space>
                        <div className="shim"></div><div className="shim"></div>
                    </div>
                </Space>

                <Divider dashed />
                {/* Show custom ship */}
                <div id="active_custom_ship" />
                <WebstoreItem
                    name="global:active_custom_ship"
                    onChange={(e) => setShipChecked(e)}
                    value={(ws["global:active_custom_ship"]) ? true : false}
                    heading="Custom Ship Checkout Button"
                    description={<div>Incorporate a personalized checkout choice mirroring the functionality of the shipping option.
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        <Form.Item name="global:label_custom_ship" initialValue={ws["global:label_custom_ship"]}>
                            <Input placeholder="Custom button label..." disabled={!shipChecked} maxLength={100} style={{ "maxWidth": "500px" }}></Input>
                        </Form.Item>
                        <Form.Item valuePropName="checked" name="global:label_override_ship" initialValue={ws["global:label_override_ship"]}>
                            <Checkbox>Use the above button wording for the <strong>Delivery Preference</strong> text shown during checkout. Left unchecked, the customer's shipping address will be displayed (the default).</Checkbox>
                        </Form.Item>
                    </div>}
                />

                <Divider dashed />
                {/* Show custom pickup */}
                <div id="active_custom_pickup" />
                <WebstoreItem
                    name="global:active_custom_pickup"
                    onChange={(e) => setPickupChecked(e)}
                    value={(ws["global:active_custom_pickup"]) ? true : false}
                    heading="Custom Pickup Checkout Button"
                    description={<div>Incorporate a personalized checkout choice mirroring the functionality of the pickup option.

                        <div className="shim" /><div className="shim" /><div className="shim" />
                        <Form.Item name="global:label_custom_pickup" initialValue={ws["global:label_custom_pickup"]}>
                            <Input placeholder="Custom button label..." disabled={!pickupChecked} maxLength={100} style={{ "maxWidth": "500px" }}></Input>
                        </Form.Item>
                        <Form.Item valuePropName="checked" name="global:label_override_pickup" initialValue={ws["global:label_override_pickup"]}>
                            <Checkbox>Use the above button wording for the <strong>Delivery Preference</strong> text shown during checkout. Left unchecked, <strong>Pick Up</strong> In Store will be displayed (the default).</Checkbox>
                        </Form.Item>
                    </div>}
                />




            </div>
        </>
    )
}